import { mountComponent } from '@/utils';
import React, { useEffect } from 'react';
import { useForm, FormProvider, useFormContext } from 'react-hook-form';
import { PartnerFormValues } from '@/types';
import { usePartnerEdit } from '../hook/usePartnerEdit';
import { PartnerForm } from './partnerForm';

export const PartnerEdit: React.FC = () => {
  const {
    formState: { errors },
    handleSubmit,
    setValue,
  } = useFormContext<PartnerFormValues>();

  const { fetchPartner, updatePartner } = usePartnerEdit();

  useEffect(() => {
    const f = async (): Promise<void> => {
      const id = window.location.pathname.split('/')[3];
      const partner = await fetchPartner(id);
      setValue('name', partner.name);
      setValue('nameKana', partner.nameKana);
      setValue('phoneNumber', partner.phoneNumber);
      setValue('postalCode', partner.postalCode);
      setValue('prefecture', partner.prefecture);
      setValue('city', partner.city);
      setValue('street', partner.street);
      setValue('building', partner.building);
      setValue('companyName', partner.companyName);
    };
    f();
  }, [fetchPartner, setValue]);

  const onSubmit = async (data: PartnerFormValues) => {
    const id = window.location.pathname.split('/')[3];
    const requestBody = {
      partner: {
        phone_number: data.phoneNumber,
        postal_code: data.postalCode,
        prefecture: data.prefecture,
        city: data.city,
        street: data.street,
        building: data.building,
        company_name: data.companyName,
        name: data.name,
        name_kana: data.nameKana,
      },
    };

    try {
      await updatePartner(id, requestBody);
      alert('講師情報を更新しました！');
    } catch (error) {
      alert('情報の更新に失敗しました');
      throw new Error(String(error));
    }
  };

  return (
    <>
      <div className='progress-bar w-100'>
        <div className='bar h-100 w-50 bg-black'></div>
      </div>
      <div className='partner-information p-3'>
        {Object.keys(errors).length > 0 && (
          <div className='alert alert-danger'>
            <ul>
              {errors.name && <li>{errors.name.message as string}</li>}
              {errors.nameKana && (
                <li>{errors.nameKana.message as string}</li>
              )}
              {errors.phoneNumber && (
                <li>{errors.phoneNumber.message as string}</li>
              )}
              {errors.postalCode && (
                <li>{errors.postalCode.message as string}</li>
              )}
              {errors.prefecture && (
                <li>{errors.prefecture.message as string}</li>
              )}
              {errors.city && <li>{errors.city.message as string}</li>}
              {errors.street && <li>{errors.street.message as string}</li>}
            </ul>
          </div>
        )}
        <form onSubmit={handleSubmit(onSubmit)}>
          <PartnerForm />
          <div className='mt-2'>
            <button
              type='submit'
              className='w-100 py-2 rounded text-white font-weight-bold bg-primary border border-primary'
            >
              保存する
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

const App: React.FC = () => {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      <PartnerEdit />
    </FormProvider>
  );
};

mountComponent('#partnerEdit', () => <App />);
